<template>
	<portal>
		<transition name="modal-anim">
			<div class="modal-wrap" v-if="open">
				<div class="modal--bg"></div>
				<div class="modal">
					<div class="modal__close">
						<Action title="Close" @click="open = false">
							<IconClose />
						</Action>
					</div>
					<div class="modal__content">
						<slot />
					</div>
				</div>
			</div>
		</transition>
	</portal>
</template>

<script>
import Action from '@/components/shared/Action'
import IconClose from 'mdi-vue/Close'

export default {
	name: 'Modal',
	props: {
		value: Boolean
	},
	computed: {
		open: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	components: {
		Action,
		IconClose
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';
@import '~scss/layout';
@import '~scss/mq';

.modal-wrap {
	@extend %flex-center;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	z-index: 1000;
}

.modal {
	@extend %flex-col;
	position: relative;
	color: $black;
	background-color: $white;
	width: 100%;
	height: 100%;
	overflow-y: auto;

	&--bg {
		@extend %abs-full;
		background-color: rgba($black, 0.75);
	}

	&__close {
		position: absolute;
		top: 0.5rem;
		right: 0.5rem;
	}

	&__content {
		@include truncate-margin;
		flex-grow: 1;
		padding: 1.5rem 2.5rem 1.5rem 1.5rem;
	}

	@include mq(md) {
		width: 37.5rem;
		height: auto;
		max-height: 60vh;
	}
}

.modal-anim {
	$spd: $spd-page;

	&-enter,
	&-leave-to {
		.modal {
			transform: translate3d(0, 100vh, 0);
			&--bg {
				opacity: 0;
			}
		}
	}
	&-enter-active,
	&-leave-active {
		// Dummy transition
		transition: left $spd;
		.modal--bg {
			transition: opacity $spd;
		}
	}
	&-enter-active {
		.modal {
			transition: transform $spd $ease-out-sine;
		}
	}
	&-leave-active {
		.modal {
			transition: transform $spd $ease-in-sine;
		}
	}
}
</style>
